import type { DefaultTheme } from 'styled-components';
import type { RuleSet } from 'styled-components';
import { css } from 'styled-components';

type ThemeProps = { theme: DefaultTheme };

type VariantTheme = {
  default: (props: ThemeProps) => RuleSet;
  hover: (props: ThemeProps) => RuleSet;
  disabled: (props: ThemeProps) => RuleSet;
  loadingColor: string;
};

export const themeByVariant: Record<
  'filled' | 'outlined' | 'text',
  Record<'primary' | 'secondary' | 'error', VariantTheme>
> = {
  filled: {
    primary: {
      default: ({ theme: { colors } }) => css`
        color: ${colors.white};
        background: ${colors.primary.main};
      `,
      hover: ({ theme: { colors } }) => css`
        background: ${colors.primary.dark};
        color: ${colors.white};
      `,
      disabled: ({ theme: { colors } }) => css`
        background: ${colors.highlight.blue25};
        color: ${colors.primary.disabled};
      `,
      loadingColor: 'white',
    },
    secondary: {
      default: ({ theme: { colors } }) => css`
        color: ${colors.text.secondary};
        background: ${colors.highlight.gray25};
      `,
      hover: ({ theme: { colors } }) => css`
        background: ${colors.highlight.gray40};
        color: ${colors.text.primary};
      `,
      disabled: ({ theme: { colors } }) => css`
        background: ${colors.highlight.gray25};
        color: ${colors.text.disabled};
      `,
      loadingColor: 'text.secondary',
    },
    error: {
      default: ({ theme: { colors } }) => css`
        color: ${colors.white};
        background: ${colors.error.main};
      `,
      hover: ({ theme: { colors } }) => css`
        background: ${colors.error.dark};
        color: ${colors.white};
      `,
      disabled: ({ theme: { colors } }) => css`
        background: ${colors.error.light};
        color: ${colors.text.disabled};
      `,
      loadingColor: 'white',
    },
  },
  outlined: {
    primary: {
      default: ({ theme: { colors } }) => css`
        color: ${colors.primary.main};
        background: transparent;
        border: 1px solid ${colors.primary.main};
      `,
      hover: ({ theme: { colors } }) => css`
        background: ${colors.highlight.blue25};
        color: ${colors.primary.dark};
        border-color: ${colors.primary.dark};
      `,
      disabled: ({ theme: { colors } }) => css`
        color: ${colors.primary.disabled};
        border-color: ${colors.primary.disabled};
        background: transparent;
      `,
      loadingColor: 'primary.main',
    },
    secondary: {
      default: ({ theme: { colors } }) => css`
        color: ${colors.text.secondary};
        background: transparent;
        border: 1px solid ${colors.divider};
      `,
      hover: ({ theme: { colors } }) => css`
        background: ${colors.highlight.gray25};
        color: ${colors.text.primary};
        border-color: ${colors.text.secondary};
      `,
      disabled: ({ theme: { colors } }) => css`
        color: ${colors.text.disabled};
        border-color: ${colors.divider};
        background: transparent;
      `,
      loadingColor: 'text.secondary',
    },
    error: {
      default: ({ theme: { colors } }) => css`
        color: ${colors.error.main};
        background: transparent;
        border: 1px solid ${colors.error.main};
      `,
      hover: ({ theme: { colors } }) => css`
        background: ${colors.error.light};
        color: ${colors.error.dark};
        border-color: ${colors.error.dark};
      `,
      disabled: ({ theme: { colors } }) => css`
        color: ${colors.text.disabled};
        border-color: ${colors.divider};
        background: transparent;
      `,
      loadingColor: 'error.main',
    },
  },
  text: {
    primary: {
      default: ({ theme: { colors } }) => css`
        color: ${colors.primary.main};
        background: transparent;
      `,
      hover: ({ theme: { colors } }) => css`
        background: ${colors.highlight.blue25};
        color: ${colors.primary.dark};
      `,
      disabled: ({ theme: { colors } }) => css`
        color: ${colors.primary.disabled};
        background: transparent;
      `,
      loadingColor: 'primary.main',
    },
    secondary: {
      default: ({ theme: { colors } }) => css`
        color: ${colors.text.secondary};
        background: transparent;
      `,
      hover: ({ theme: { colors } }) => css`
        background: ${colors.highlight.gray25};
        color: ${colors.text.primary};
      `,
      disabled: ({ theme: { colors } }) => css`
        color: ${colors.text.disabled};
        background: transparent;
      `,
      loadingColor: 'text.secondary',
    },
    error: {
      default: ({ theme: { colors } }) => css`
        color: ${colors.error.main};
        background: transparent;
      `,
      hover: ({ theme: { colors } }) => css`
        background: ${colors.error.light};
        color: ${colors.error.dark};
      `,
      disabled: ({ theme: { colors } }) => css`
        color: ${colors.text.disabled};
        background: transparent;
      `,
      loadingColor: 'error.main',
    },
  },
};
